/**
 * Номер для входа в PWA — в виде, который принимает сервер (`^\+?[1-9]\d{9,14}$`): человек вводит
 * «+7 999 123-45-67», «8 (999) 123 45 67» или «9991234567», а раньше уходило как есть и получало 422.
 * Российский номер приводится к +7XXXXXXXXXX: 11 цифр с 8 или 7 в начале, либо 10 цифр с 9 в начале.
 * Остальное — цифры с «+», если человек его поставил (международный номер), иначе только цифры.
 * Локальная функция PWA: общий модуль номеров ядра появится с PR #16 — тогда сведём к нему.
 */
export function normalizeLoginPhone(raw: string): string {
  const trimmed = raw.trim();
  const digits = trimmed.replace(/\D/g, '');
  if (digits.length === 11 && (digits[0] === '8' || digits[0] === '7')) {
    return `+7${digits.slice(1)}`;
  }
  if (digits.length === 10 && digits[0] === '9') {
    return `+7${digits}`;
  }
  return trimmed.startsWith('+') ? `+${digits}` : digits;
}

/** Номер годится для отправки: после нормализации — то, что принимает сервер. */
export function isValidLoginPhone(raw: string): boolean {
  return /^\+?[1-9]\d{9,14}$/.test(normalizeLoginPhone(raw));
}
